// test1576
(1576 && 0);
